import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { useLocation } from 'react-router'

import type { MenuItem as MenuItemType } from '../lib/MenuItem'

type Props = {
  menuItem: MenuItemType
}

export const MenuItem = ({ menuItem }: Props) => {
  const { pathname } = useLocation()
  return (
    <ListItemButton
      role="menuitem"
      target={menuItem.openBlank ? '_blank' : undefined}
      href={menuItem.linkTo}
      selected={pathname === menuItem.linkTo}
    >
      <ListItemText primary={menuItem.primaryText} secondary={menuItem.secondaryText} />
      <ListItemIcon sx={{ minWidth: 40 }}>{menuItem.icon}</ListItemIcon>
    </ListItemButton>
  )
}
